/** 深拷贝 ImageData（用于裁剪前备份） */
export function cloneImageData(src: ImageData): ImageData {
  return new ImageData(new Uint8ClampedArray(src.data), src.width, src.height);
}

export interface FrameCropRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** 从 ImageData 裁切矩形区域（坐标为像素、含边界裁剪） */
export function cropImageData(
  src: ImageData,
  x: number,
  y: number,
  w: number,
  h: number
): ImageData {
  const sx = Math.max(0, Math.floor(x));
  const sy = Math.max(0, Math.floor(y));
  let sw = Math.floor(w);
  let sh = Math.floor(h);
  sw = Math.min(sw, src.width - sx);
  sh = Math.min(sh, src.height - sy);
  if (sw <= 0 || sh <= 0) {
    return new ImageData(1, 1);
  }

  const full = document.createElement("canvas");
  full.width = src.width;
  full.height = src.height;
  const fctx = full.getContext("2d");
  if (!fctx) return cloneImageData(src);
  fctx.putImageData(src, 0, 0);

  const out = document.createElement("canvas");
  out.width = sw;
  out.height = sh;
  const octx = out.getContext("2d");
  if (!octx) return cloneImageData(src);
  octx.drawImage(full, sx, sy, sw, sh, 0, 0, sw, sh);
  return octx.getImageData(0, 0, sw, sh);
}

/** 计算默认居中裁剪框（尺寸不超过图与 default 尺寸） */
export function getDefaultCropRect(
  imageWidth: number,
  imageHeight: number,
  defaultCropWidth: number,
  defaultCropHeight: number
): FrameCropRect {
  const bw = Math.min(Math.max(1, defaultCropWidth), imageWidth);
  const bh = Math.min(Math.max(1, defaultCropHeight), imageHeight);
  return {
    x: Math.floor((imageWidth - bw) / 2),
    y: Math.floor((imageHeight - bh) / 2),
    width: bw,
    height: bh,
  };
}
